var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResearch = function SvgResearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBADB",
    d: "M18.63 16.162a9.04 9.04 0 0 0 1.55-5.07C20.18 6.078 16.101 2 11.09 2S2 6.079 2 11.091c0 5.013 4.078 9.091 9.09 9.091a9.04 9.04 0 0 0 5.066-1.547l2.854 2.854a1.75 1.75 0 0 0 2.472 0c.69-.682.69-1.791 0-2.482zm-7.54 2.202c-4.01 0-7.272-3.263-7.272-7.273S7.08 3.818 11.09 3.818s7.272 3.263 7.272 7.273-3.263 7.273-7.272 7.273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABBADB",
    d: "M6.321 10.104a.947.947 0 1 1 1.894 0v3.788a.947.947 0 1 1-1.894 0zM10.108 8.21a.947.947 0 1 1 1.894 0v5.682a.947.947 0 1 1-1.894 0zM13.896 11.998a.947.947 0 1 1 1.893 0v1.894a.947.947 0 1 1-1.893 0z"
  })));
};
export default SvgResearch;